import {
	SwiperState,
	SET_ITEMS_IN_MODULE_SWIPER,
	SET_DRAG_ITEM_ID,
	SET_SELECTED_ITEM_ID,
	SET_MODULE_ITEMS_CHANGED,
	SET_SWIPER_EVENT_TYPE,
} from './types';
import { Actions } from '..';
import { SET_SCENE_DATA } from '../scene/types';

const initialState: SwiperState = {
	moduleItems: [],
	dragItemId: null,
	eventType: null,
	previousDraggedItemId: null,
	selectedItemId: null,
	previousSelectedItemId: null,
	moduleItemsChanged: false,
};

export function swiperReducer(state = initialState, action: Actions): SwiperState {
	switch (action.type) {
		case SET_ITEMS_IN_MODULE_SWIPER:
			return { ...state, moduleItems: action.value };
		case SET_DRAG_ITEM_ID:
			if (action.value !== null) {
				return { ...state, dragItemId: action.value, previousDraggedItemId: action.value };
			}
			return { ...state, dragItemId: action.value };
		case SET_SWIPER_EVENT_TYPE:
			return { ...state, eventType: action.value.type };
		case SET_SELECTED_ITEM_ID:
			if (action.value !== null) {
				return { ...state, selectedItemId: action.value, previousSelectedItemId: action.value };
			}
			return { ...state, selectedItemId: action.value };
		case SET_SCENE_DATA: {
			// Update the module item statuses
			const { articlesPlaceable } = action;
			const { moduleItems } = state;
			const newItems = moduleItems.map((item) => {
				const status = articlesPlaceable[item.id];
				return { ...item, disabled: !status };
			});
			return { ...state, moduleItems: newItems };
		}
		case SET_MODULE_ITEMS_CHANGED:
			return { ...state, moduleItemsChanged: action.value };
		default:
			return state;
	}
}
